import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2ContributionsResponse,
  IIndirectTaxFilingV2MutationResult,
  IIndirectTaxFilingV2UpdateContributionsParams,
} from './types';

export async function updateIndirectTaxFilingV2Contributions({
  filingId,
  params,
  token,
}: {
  filingId: string;
  params: IIndirectTaxFilingV2UpdateContributionsParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2ContributionsResponse>
> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings-v2/${filingId}/contributions`,
      { method: 'POST', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to update filing contributions',
      };
    }
    const data: IIndirectTaxFilingV2ContributionsResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to update filing contributions',
    };
  }
}
